export function isCourtPortal(): boolean {
  const publicHostNames = ['courts.ftrdev.com', 'courts.fortherecord.com']
  const hostName = window.location.host
  return publicHostNames.includes(hostName)
}
